'use strict';

/* globals config, $, utils */

require([
	config.relative_path + '/plugins/nodebb-plugin-courses/static/vendor/vue.js',
	'coverPhoto',
	'pictureCropper',
], function (Vue, coverPhoto, pictureCropper) {
	var internals = {};

	Vue.component('creator-edit-video', {
		props: ['videoContainer', 'initData'],
		data: function () {
			return {
				label: this.initData.translations.uploadVideo,
				icon: 'fa fa-video-camera',
				uuid: utils.generateUUID(),
			};
		},
		mounted: function () {
			this.$nextTick(function () {
				$('.' + this.uuid, this.$el).customVideo();
			});
		},
		computed: {
			hasUploadedVideo() {
				return /^video:/.test(this.videoContainer.video);
			}
		},
		methods: {
			onUploadSuccess: function (video) {
				this.saveFilePermissions(video.name);
				this.videoContainer.video = video.url;

				this.$nextTick(function () {
					$('.' + this.uuid, this.$el).customVideo();
				});
			},
			removeVideo: function () {
				this.videoContainer.video = null;
			},
			selectImage: function () {
				var me = this;

				internals.openSelectImage(function (imageUrl) {
					me.$set(me.videoContainer, 'videoThumbnail', imageUrl);

					me.saveFilePermissions(imageUrl);
				});
			},
			removeImage: function () {
				this.videoContainer.videoThumbnail = null;
			},
		},
		template:
			'<div>' +
				'<div>' +
					'<div class="row" v-if="videoContainer.video">' +
						'<div class="col-lg-6 col-md-8 col-sm-12">' +
							'<div :class="uuid" :data-video-url="videoContainer.video"></div>' +
						'</div>' +
					'</div>' +
					'<button v-if="hasUploadedVideo" class="btn btn-danger" type="button" v-on:click="removeVideo()">' +
						'{{initData.translations.removeVideo}}' +
					'</button>' +
					'<div v-if="!hasUploadedVideo">' +
						'<div class="row">' +
							'<div class="col-lg-6 col-md-8 col-sm-12"><input type="text" class="form-control" v-model="videoContainer.video" :placeholder="initData.translations.ytVideo" /></div>' +
						'</div>' +
						'<div class="row">' +
							'<div class="col-lg-6 col-md-8 col-sm-12"><upload-component :label="label" :icon="icon" :onUploadSuccess="onUploadSuccess"></upload-component></div>' +
						'</div>' +
					'</div>' +
				'</div>' +
				'<div v-if="videoContainer.video">' +
					'<div class="row" v-if="videoContainer.videoThumbnail">' +
						'<div class="col-lg-6 col-md-8 col-sm-12">' +
							'<img :src="videoContainer.videoThumbnail" alt="" style="width: 100%" />' +
						'</div>' +
					'</div>' +
					'<button v-if="videoContainer.videoThumbnail" class="btn btn-danger" type="button" v-on:click="removeImage()">' +
						'{{initData.translations.removeThumbnail}}' +
					'</button>' +
					'<button v-if="!videoContainer.videoThumbnail" class="btn btn-primary" type="button" v-on:click="selectImage()">' +
						'<i class="fa fa-picture-o" aria-hidden="true"></i> {{initData.translations.addThumbnail}}' +
					'</button>' +
				'</div>' +
			'</div>',
	});

	internals.openSelectImage = function (onSuccess) {
		pictureCropper.show({
			title: '[[ideas-board:select-image]]',
			socketMethod: 'plugins.courses.uploadPicture',
			aspectRatio: NaN,
			allowSkippingCrop: true,
			restrictImageDimension: false,
		}, onSuccess);
	};
});
